import { connect } from 'react-redux';

import Navbar from '../../components/Navbar';

const mapStateToProps = state => {
  function checkInformationStatuses() {
    let attention = false;

    // forms
    if (!attention && state.status.member1 === 'REJECTED') attention = true;
    if (
      !attention &&
      state.application.showMember2 &&
      state.status.member2 === 'REJECTED'
    )
      attention = true;
    if (!attention && state.status.apartment1 === 'REJECTED') attention = true;
    if (
      !attention &&
      state.application.showApartment2 &&
      state.status.apartment2 === 'REJECTED'
    )
      attention = true;
    if (!attention && state.status.swapReason === 'REJECTED') attention = true;
    if (!attention && state.status.details1 === 'REJECTED') attention = true;
    if (
      !attention &&
      state.application.showDetails2 &&
      state.status.details2 === 'REJECTED'
    )
      attention = true;

    // documents
    if (!attention && state.status.minUc === 'REJECTED') attention = true;
    if (!attention && state.status.proofOfId === 'REJECTED') attention = true;
    if (!attention && state.status.incomeBase === 'REJECTED') attention = true;
    if (!attention && state.status.rentalAgreement === 'REJECTED')
      attention = true;
    if (!attention && state.status.rentalBase === 'REJECTED') attention = true;

    return attention;
  }

  return {
    attentionDot: checkInformationStatuses(),
    makeSpaceForNotificationBar: state.notificationBar.shouldShow,
  };
};

export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/features/Navbar/index.js